import { colors } from "../../utils/const";

export const styles = {
  container: {
    alignSelf: "center",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    // alignItems: "space-between",
    bgcolor: "#FAFAFA",
    width: { xs: "100%", sm: "1200px" },
    height: "905px",
    // width: { xs: "300px", sm: "500px" },
    p: 3,
    borderRadius: 3,
    gap: 2,
    zIndex: 100,
  },
  inputWrapper: (theme) => ({ flex: "2 1 auto", mt: 2 }),
  label: (theme) => ({
    fontWeight: "bold",
    fontSize: "17px",
    color: colors.manhattan_blue,
    pb: 0.8,
  }),
  input: {
    // "& MuiSelect-select": { height: "300px" },
    mb: 0.5,
    width: { xs: "100%", sm: "488px" },
    height: "48px",
    bgcolor: "#F5F5F6",
    borderRadius: 2,
    "& p": {
      bgcolor: "white",
      m: 0,
    },
    "& fieldset": {
      borderRadius: 2,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "grey",
      },
    },
  },
  inputMessage: {
    // "& MuiSelect-select": { height: "300px" },
    mb: "24px",
    width: { xs: "327px", sm: "488px" },
    width: "100%",
    height: "93px",
    bgcolor: colors.white_smoke,
    borderRadius: 2,
    "& p": {
      bgcolor: "white",
      m: 0,
    },
    "& fieldset": {
      borderRadius: 2,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "grey",
      },
    },
  },
  helperText: (theme) => ({
    color: "#d32f2f",
    fontSize: "0.75rem",
    my: 0.3,
    mx: 1
    // mt: -1.5,
  }),
  btn: {
    width: "100%",
    height: "45px",
    // mb: "40px",
    color: colors.white,
    border: `1px solid ${colors.yellow}`,
    backgroundColor: colors.yellow,
    borderRadius: 2,
    "&:disabled": {
      color: `${colors.grey} !important`,
      border: `1px solid ${colors.light_grey} !important`,
      backgroundColor: `${colors.light_grey} !important`,
    },
  },
  application_form: {
    alignSelf: "flex-start",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    // alignItems: "space-between",
    bgcolor: colors.bg_grey,
    // width: { xs: "300px", sm: "500px" },
    p: 3,
    borderRadius: 3,
    gap: 2,
    zIndex: 100,
  },
};
